<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi"
                                           ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emArchFixedAssetDisposalResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" inlineActionsDisabled
                                      :query-api="$_emWorkflowListMixin_queryApi"
                                      :ref="modelName+'Table'"
                                      editDisable
                                      with-custom-row-actions-first-column>
                                <template slot="left-header">
                                    <b-button-group>
                                        <em-button type="add"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   custom-label="label.em.asset.emArchFixedAssetDisposal.apply"
                                                   custom-icon="fa fa-fw fa-lg fa-plus"
                                                   show-name
                                                   @click="goApply">
                                        </em-button>
                                        <em-button type="search"
                                                   v-if="isTypeTodo"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   :customLabel="isClaim ? '认领' : '待办'"
                                                   :custom-icon="'fa ' + (isClaim ? 'fa-toggle-on' : 'fa-toggle-off')"
                                                   :busy="emWorkflowListLoading"
                                                   show-name
                                                   @click="switchClaim">
                                        </em-button>
                                        <!--
                                            URS 需求_new R68 / R73 / R75 / R77 / R79：
                                            5 个「同意 / 不同意」节点可批量选择审批任务。
                                            认领模式下同一个按钮做批量认领。
                                        -->
                                        <em-button type="task"
                                                   v-if="isTypeTodo"
                                                   :busy="claimLoading || batchSubmitting"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   :custom-label="isClaim ? '批量认领' : '批量审批'"
                                                   custom-icon="fa fa-fw fa-lg fa-check-square-o"
                                                   show-name
                                                   @click="handleBatch">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button type="task"
                                                   :busy="claimLoading"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   :custom-label="isClaim ? '认领' : '处理'"
                                                   @click="handleExecute(customRowScope.row)">
                                        </em-button>
                                        <em-button type="edit"
                                                   v-if="allowModify(customRowScope.row)"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   custom-label="label.em.asset.emArchFixedAssetDisposal.modify"
                                                   custom-icon="fa fa-fw fa-pencil-alt"
                                                   @click="goModify(customRowScope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <re-b-modal ref="batchModal"
                    large
                    no-auto-hide
                    :ok-loading="batchSubmitting"
                    ok-label="提 交"
                    :header="$t('label.em.asset.emArchFixedAssetDisposal.batchApprove')"
                    @ok="submitBatch">
            <b-alert :show="!!batchMessage" variant="info" class="py-2">{{ batchMessage }}</b-alert>
            <div class="fad-batch mb-2">
                <!--
                    ⚠ 每次打开弹窗都 batchTableKey++ 重建：MiniTable 的勾选状态活在实例上，
                    不重建会把上一次的行带进来（memory mmf-minitable-checked-state）。
                    这里表格只做展示（read-only、无勾选列），重建同样保证行数据不残留。
                -->
                <mini-table :key="batchTableKey"
                            header-title=""
                            disable-header
                            read-only
                            row-key="id"
                            :fields="batchFields"
                            :items="batchRows">
                </mini-table>
            </div>
            <b-form-row>
                <b-col md="4">
                    <b-form-group :label="$t('label.em.asset.emArchFixedAssetDisposal.batchResult') + ' *'">
                        <b-form-select v-model="batchApproved" size="sm"
                                       :options="batchApproveOptions"></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col md="8">
                    <b-form-group :label="$t('label.em.asset.emArchFixedAssetDisposal.batchComment') + ' *'">
                        <b-form-textarea v-model="batchComment" size="sm" rows="2"></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-form-row>
        </re-b-modal>

        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>

<script>
// 固定资产处置 | 待办 / 列表 + 批量审批（验收 #11 的批量部分、#13 的待办部分）
// Author Liang Gangqiang
// Date 2026-09-07
//
// 与变更流程同款：emWorkflowListMixin 按 pathType 决定查的是待办（todo）、认领（claim）还是全量（list）；
// 本页只承担「待办 + 认领」两种视图（全量查询走 EmArchFixedAssetDisposalQueryView），
// 所以把 pathType 钉死成 todo，见 computed.pathType 的注释。
// assignee 型（task_disposal_init / task_owner_gate_pass）与 candidateUsers 型都能出现在待办里，
// 候选人型任务未认领时用「认领」开关切换。
//
// 批量审批为什么不用 components/workflow/WorkflowTaskBatch.vue：
//   ① 它默认打工作流服务的 /completeTaskBatch，绕开了业务侧 /emArchFixedAssetDisposal/completeTask，
//      于是「下一节点候选人解析」「两个网关业务变量刷新」整段都不会执行，下一节点没人能办；
//      而工作流服务没有「按角色解析候选人」的能力，前端也无从代劳。
//   ② 它的 packRequests 无条件塞一条 PUT /{entity}/selective，会重跑 beforeSaveTrigger 的
//      全量校验（S6 已知约束），批量审批根本不需要写业务表。
// 所以这里按行逐条打业务侧 completeTask：每条都带齐 fromTask / nextTask / taskUserKey /
// processInstanceBusinessKey（等价于单条审批页的 need-pre-values 四件套），
// 全部走 POST body，不拼 query string（memory mmf-batch-request-header-limit）。

import emWorkflowListMixin from "@/mixin/em/workflow/list";
import claimTaskMixins from "@/components/workflow/mixin/ClaimTaskMixins";
import emCommonApiMixin from "@/mixin/em/common/api";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import {BATCH_APPROVE_STATUSES} from "@/model/em/asset/EmArchFixedAssetDisposalModel";

// 「不同意」一律退回申请人；BPMN 的 5 条回退线全部指向 task_disposal_init
const REJECT_NEXT_TASK = 'task_disposal_init';

// approved == 1 时各审批节点的下一节点（Gateway_* 的「同意」出边）
const AGREE_NEXT_TASK = {
    task_dept_manager_confirm: 'task_finance_type',
    task_finance_manager_confirm: 'task_asset_manager_confirm',
    task_asset_manager_confirm: 'task_cm_confirm',
    task_cm_confirm: 'task_gm_confirm'
};

// GM 同意后按处置意见分流（Gateway_gm → Gateway_disposal_opinion 的三条出边）
const GM_NEXT_TASK_BY_OPINION = {
    SCRAP: 'task_finance_write_off',
    // 废料处理改走资产负责人出门证（与评估售卖一致）；旧版定义的在途实例由后端 completeTask 补写旧节点变量兜底
    WASTE_HANDLING: 'task_owner_gate_pass',
    EVALUATED_SALE: 'task_owner_gate_pass'
};

// assignee 型节点，taskUserKey 后缀是 _assignee 而不是 _candidateUsers
const ASSIGNEE_TASKS = ['task_disposal_init', 'task_owner_gate_pass'];

export default {
    name: "emArchFixedAssetDisposalWorkflowListView",
    components: {MiniTable, ReBModal},
    mixins: [emWorkflowListMixin, claimTaskMixins, emCommonApiMixin],
    data() {
        return {
            batchRows: [],
            batchTableKey: 0,
            batchApproved: 1,
            batchComment: '',
            batchMessage: '',
            batchSubmitting: false,
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },

        /**
         * 覆写 ClaimTaskMixins.pathType：不管路由带的 pathType 是什么，本页一律按「待办」处理。
         *
         * 为什么：左侧菜单跳转时会把菜单的 crudCode 原样塞进 ?pathType=
         * （EmSidebar3Level#routeTo / EmSidebar 的 router-link），本页菜单当初按 crudCode=list 注册，
         * 于是从菜单进来是 pathType=list → isTypeTodo=false →「认领 / 待办」开关、批量按钮和「修改」按钮
         * 都不渲染，「处理」进 Task 页也只读（Task 页只在 pathType=todo 时显示提交区）。
         * 而铃铛 / 通知深链和发起页保存后的跳转都带 pathType=todo，所以那几条路是好的。
         * 菜单数据该改成 crudCode=todo，但本页不应再依赖它：在这里归一，菜单配成什么都能用。
         */
        pathType() {
            return 'todo';
        },

        /**
         * 同步覆写 ClaimTaskMixins 的同名 computed：它读的是 $route.query.pathType，
         * 不跟着改的话 emWorkflowListMixin 查询用的 workflowQueryTypeFilter 仍会是 list。
         */
        $_emRouterHelperMixin_pathType() {
            return this.isClaim ? 'claim' : this.pathType;
        },

        completeTaskApi() {
            return process.env.VUE_APP_EM_ARCHIVE_URL + '/emArchFixedAssetDisposal/completeTask';
        },
        batchApproveOptions() {
            return [
                {value: 1, text: this.$t('label.em.asset.emArchFixedAssetDisposal.agree')},
                {value: 2, text: this.$t('label.em.asset.emArchFixedAssetDisposal.reject')}
            ];
        },
        batchFields() {
            let prefix = 'label.em.asset.emArchFixedAssetDisposal.grid.';
            return [
                {key: 'workOrderCode', label: prefix + 'workOrderCode'},
                {key: 'statusName', label: prefix + 'statusName'},
                {key: 'applicantName', label: prefix + 'applicantName'},
                {key: 'applyDeptName', label: prefix + 'applyDeptName'},
                {key: 'applyTime', label: prefix + 'applyTime'},
                {key: 'disposalReason', label: prefix + 'disposalReason'},
            ];
        },
    },
    methods: {
        /**
         * 只有 task_disposal_init 允许修改（EM_ACT_PROCESS_STATUS.allow_modify=true）。
         * 该列由工作流注册表提供，行数据缺失时按「不可改」处理，不要让按钮凭空出现。
         */
        allowModify(row) {
            return this.isTypeTodo && !this.isClaim && row && row.statusAllowModify === true;
        },

        goApply() {
            this.$router.push({path: '/em/asset/emArchFixedAssetDisposalEdit'});
        },

        goModify(row) {
            this.$router.push({
                path: '/em/asset/emArchFixedAssetDisposalEdit',
                query: {id: row.id}
            });
        },

        /**
         * 认领模式 → 批量认领（ClaimTaskMixins 已有）；待办模式 → 打开批量审批弹窗。
         */
        handleBatch() {
            if (!this.$_checked) {
                this.toast(this.$t('label.em.asset.emArchFixedAssetDisposal.batchNoSelection'), 'warning');
                return;
            }
            if (this.isClaim) {
                this.doClaimBatch();
                return;
            }
            let rows = this.checkedRows || [];
            let status = rows[0].status;
            for (let row of rows) {
                if (row.status !== status) {
                    this.toast(this.$t('label.em.asset.emArchFixedAssetDisposal.batchSameStatus'), 'warning');
                    return;
                }
            }
            if (BATCH_APPROVE_STATUSES.indexOf(status) < 0) {
                // 财务选类型 / 采购选意见 / 两个出门证 / 销账都要逐单录业务字段，不支持批量
                this.toast(this.$t('label.em.asset.emArchFixedAssetDisposal.batchUnsupported'), 'warning');
                return;
            }
            let missingTask = rows.filter(o => !this.taskInstanceId(o));
            if (missingTask.length > 0) {
                this.toast(this.$t('label.em.asset.emArchFixedAssetDisposal.batchNeedClaim'), 'warning');
                return;
            }
            this.batchRows = rows.slice();
            this.batchApproved = 1;
            this.batchComment = '';
            this.batchMessage = '';
            this.batchTableKey++;
            this.$refs.batchModal.showModal();
        },

        taskInstanceId(row) {
            return row && row.workflowTask ? row.workflowTask.taskInstanceId : null;
        },

        /**
         * 逐条提交（每条都是独立的 taskId / businessKey / nextTask，本来就没法合成一次请求）。
         * 首条失败即中止，如实播报「成功 N / 共 M」，并且无论成败都重新查询以反映真实状态
         * （memory mmf-batch-request-header-limit 的做法）。
         */
        submitBatch() {
            if (this.batchSubmitting) {
                return;
            }
            if (!this.batchComment) {
                this.batchMessage = this.$t('label.em.asset.emArchFixedAssetDisposal.batchCommentRequired');
                return;
            }
            this.batchMessage = '';
            this.batchSubmitting = true;
            let rows = this.batchRows.slice();
            let done = 0;
            let submitOne = index => {
                if (index >= rows.length) {
                    return Promise.resolve(true);
                }
                return this.$_emApiMixin_post(this.completeTaskApi, this.buildTaskForm(rows[index]))
                        .then(() => {
                            done++;
                            return submitOne(index + 1);
                        })
                        // 失败提示由 store/api.js 的 error action 统一弹，这里只负责中止
                        .catch(() => false);
            };
            submitOne(0).then(allDone => {
                this.toast(
                        `${this.$t('label.em.asset.emArchFixedAssetDisposal.batchDone')}：${done} / ${rows.length}`,
                        allDone ? 'success' : 'warning');
            }).finally(() => {
                this.batchSubmitting = false;
                this.$refs.batchModal.hide();
                this.batchRows = [];
                this.batchTableKey++;
                this.$refs['emListFilter'].doQuery();
            });
        },

        /**
         * 等价于单条审批页 WorkflowTaskComplete 在 needPreValues 打开时拼的 taskForm：
         * fromTask / nextTask / taskUserKey / processInstanceBusinessKey 四件套一个都不能少，
         * 否则业务侧 findByBusinessKey(null) 返回 null，候选人与网关变量全不写且不报错。
         */
        buildTaskForm(row) {
            let nextTask = this.resolveNextTask(row, this.batchApproved);
            return {
                taskId: this.taskInstanceId(row),
                approved: this.batchApproved,
                comment: this.batchComment,
                attachmentIds: null,
                variables: {},
                taskAssigneeMap: {},
                callbackApi: this.$store.state[this.modelName].callbackApi,
                fromTask: row.status,
                nextTask: nextTask,
                taskUserKey: nextTask + (ASSIGNEE_TASKS.indexOf(nextTask) >= 0 ? '_assignee' : '_candidateUsers'),
                processInstanceBusinessKey: row.id
            };
        },

        resolveNextTask(row, approved) {
            if (approved !== 1) {
                return REJECT_NEXT_TASK;
            }
            if (row.status === 'task_gm_confirm') {
                // Gateway_disposal_opinion：处置意见此刻已由采购节点写进库
                return GM_NEXT_TASK_BY_OPINION[row.disposalOpinion] || 'task_finance_write_off';
            }
            return AGREE_NEXT_TASK[row.status];
        },

        toast(message, variant) {
            this.$bvToast.toast(message, {
                variant: variant,
                noCloseButton: true,
                autoHideDelay: 4000
            });
        },
    }
};
</script>

<style scoped>
/*
   b-table 的 sticky-header 包裹层同时带着 MiniTable 的 .table-cover，而后者的
   `max-height: 100% !important` 盖掉了 bootstrap-vue 自带的 300px 上限；父级高度不是
   确定值时这个百分比解析成 none，表格就按内容整高铺开，把下面的内容盖住。
   所以直接给这一层一个确定上限：表格在自己的 sticky 容器里滚动、表头保持吸顶，
   行数少时依然按内容收缩。外层不要再加 max-height —— 那只会裁剪内容或多出一层滚动条。
*/
.fad-batch >>> .b-table-sticky-header {
    max-height: 18rem !important;
}
</style>
